/**
 * Parser de arquivos OFX (Open Financial Exchange)
 * Converte o formato SGML do OFX em transacoes estruturadas
 */

/**
 * Extrai o valor de uma tag SGML
 */
function getTagValue(content, tag) {
  const regex = new RegExp(`<${tag}>([^<\\r\\n]+)`, 'i');
  const match = content.match(regex);
  return match ? match[1].trim() : null;
}

/**
 * Parseia uma data OFX (formato YYYYMMDD ou YYYYMMDDHHMMSS)
 */
function parseOFXDate(dateStr) {
  if (!dateStr) return null;
  const clean = dateStr.replace(/\[.*\]/, '').trim();
  const year = clean.substring(0, 4);
  const month = clean.substring(4, 6);
  const day = clean.substring(6, 8);
  return `${year}-${month}-${day}`;
}

/**
 * Parseia o conteudo de um arquivo OFX e retorna transacoes estruturadas
 * @param {string} content - Conteudo do arquivo OFX
 * @returns {{ transactions: Array, accountInfo: object }}
 */
export function parseOFX(content) {
  const transactions = [];

  // Extrair info da conta
  const accountInfo = {
    bankId: getTagValue(content, 'BANKID'),
    accountId: getTagValue(content, 'ACCTID'),
    accountType: getTagValue(content, 'ACCTTYPE'),
  };

  // Encontrar todas as transacoes (STMTTRN blocks)
  const stmtTrnRegex = /<STMTTRN>([\s\S]*?)<\/STMTTRN>/gi;
  let match;

  while ((match = stmtTrnRegex.exec(content)) !== null) {
    const block = match[1];

    const trnType = getTagValue(block, 'TRNTYPE');
    const datePosted = getTagValue(block, 'DTPOSTED');
    const amount = getTagValue(block, 'TRNAMT');
    const fitId = getTagValue(block, 'FITID');
    const memo = getTagValue(block, 'MEMO');
    const name = getTagValue(block, 'NAME');
    const checkNum = getTagValue(block, 'CHECKNUM');

    if (!amount || !datePosted) continue;

    const parsedAmount = parseFloat(amount.replace(',', '.'));
    const isExpense = parsedAmount < 0;

    transactions.push({
      fitId: fitId || null,
      date: parseOFXDate(datePosted),
      description: (memo || name || trnType || 'Sem descricao').substring(0, 100),
      amount: Math.abs(parsedAmount),
      type: isExpense ? 'expense' : 'income',
      ofxType: trnType,
      checkNum: checkNum || null,
      categoryId: null, // Sera mapeado pelo usuario
    });
  }

  // Ordenar por data
  transactions.sort((a, b) => a.date.localeCompare(b.date));

  return { transactions, accountInfo };
}

/**
 * Valida se o conteudo parece ser um arquivo OFX valido
 */
export function isValidOFX(content) {
  return content.includes('<OFX>') || content.includes('<ofx>') ||
    content.includes('OFXHEADER') || content.includes('<STMTTRN>');
}
